import classNames from 'classnames';
import { Button, FlexContainer, Input, Modal, Txt } from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useProperty, useDataActions } from 'state';
import { EPCDetails } from './bricks';
import styles from './TodoItemEPC.module.scss';

/**
 * TodoItemEPC
 *
 * @return {JSX.Element}
 */
const TodoItemEPC = ({ className, onSuccess }) => {
  const propertyDoc = useProperty();
  const storageActions = useDataActions();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDetails, setIsOpenDetails] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState(
    () => propertyDoc.data.standards.epcUrl || ''
  );

  const handleUrlChange = ({ target: { value } }) => setCertificateUrl(value);
  const handleSubmit = async (e) => {
    console.log('Submit');
    e.preventDefault();
    setIsLoading(true);
    await storageActions.property.updateEPCUrl(propertyDoc, certificateUrl);
    setIsLoading(false);
    return onSuccess && onSuccess();
  };

  const handleOpenDetails = () => setIsOpenDetails(true);
  const handleCloseDetails = () => setIsOpenDetails(false);

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemEPC,
        className,
        TodoItemEPC.displayName
      )}
      column
      gap
    >
      <Txt>
        {propertyDoc.data.standards.epcUrl
          ? 'This property has a valid EPC  🎉'
          : '🔁 An EPC is valid for 10 years.'}
      </Txt>
      <Txt regular>
        A valid energy performance certificate is required by law and provides
        tenants a good outlook on energy usage and efficiency.
      </Txt>
      <Button success onClick={handleOpenDetails} disabled={isLoading}>
        View EPC details
      </Button>
      <Txt regular>
        To present this certificate to your tenants please follow these steps:
      </Txt>
      <ol className={styles.List}>
        <li>Go to GOV.UK using the button below.</li>
        <li>Find this property in the national register.</li>
        <li>Copy the link then paste it below when you’re ready.</li>
      </ol>
      <a
        className={styles.Link}
        href={`https://find-energy-certificate.service.gov.uk/find-a-certificate/search-by-postcode?postcode=${propertyDoc.data.address.postcode?.replace(
          ' ',
          ''
        )}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <Button reverse>Go to GOV.UK</Button>
      </a>
      <form onSubmit={handleSubmit}>
        <FlexContainer column gap>
          <FlexContainer column gapHalf>
            <Txt xx bold>
              Energy performance certificate url
            </Txt>
            <Input
              flex
              reverse
              value={certificateUrl}
              onChange={handleUrlChange}
              disabled={isLoading}
            />
          </FlexContainer>
          <Button type="submit" success disabled={isLoading || !certificateUrl}>
            Save
          </Button>
        </FlexContainer>
      </form>
      {isOpenDetails ? (
        <Modal onClose={handleCloseDetails} noPadding>
          <EPCDetails />
        </Modal>
      ) : null}
    </FlexContainer>
  );
};

TodoItemEPC.displayName = 'TodoItemEPC';

export default observer(TodoItemEPC);
